import { put, call } from 'redux-saga/effects';
import { Types } from './actions';
import BseDataRepository from '../../../../data/repositories/BseDataRepository';
import BseRepository from '../../../repositories/BseRepository';

const bseRepository: BseRepository = new BseDataRepository();

export default function* execute({ ids }: any): any {
  try {
    yield put({ type: Types.DELETE_FILE_BSE_REQUEST });

    if (Array.isArray(ids)) {
      let index = 0;
      const response: any[] = [];

      while (index < ids.length) {
        response[index] = yield call(bseRepository.deleteFileBse, ids[index]);
        yield put({
          type: Types.DELETE_FILE_BSE_SUCCESS,
          data: response
        });
        index += 1;
      }
      yield put({
        type: Types.DELETE_FILE_BSE_SUCCESS,
        data: response
      });
    } else {
      const response = yield call(bseRepository.deleteFileBse, ids);

      if (!response) {
        yield put({
          type: Types.DELETE_FILE_BSE_FAILURE,
          error: true
        });
        return;
      }

      yield put({
        type: Types.DELETE_FILE_BSE_SUCCESS,
        data: response
      });
    }
  } catch (error) {
    yield put({
      type: Types.DELETE_FILE_BSE_FAILURE,
      error: 'Ocurrió un error al momento de borrar el archivo'
    });
  }
}
